import React, {ReactNode} from 'react';
import Page from '@episerver/spa-core/Page';
import LaunchInContextExternalPageData from '../../../Models/Content/LaunchInContextExternalPageData';
import JetRedirectDataData from '../../../Models/Content/JetRedirectDataData';
import helper from '../../../utilities/helper';
import authenticationProvider from '../../../utilities/authentication/authenticationProvider';

export default class LaunchInContextExternalPage extends Page<LaunchInContextExternalPageData> {
  public pageDidMount() {
    // extract url parameters
    // build login url
    // redirect to login.
    const actionKey = {
      '0': 'Abroad',
      '1': 'DebtPaymentBit',
      '2': 'ComplitRegistrationEcommerce',
      '3': 'LoginEcommerce',
      '4': 'OwnershipTransfer',
      '5': 'CouponHistory',
      '6': 'HboRedirect',
      '7': 'Invoice',
      '8': 'DisneyRedirect',
    };
    const loginTypeEnum = {
      '0': 'CREDENTIALS',
      '1': 'SILENTLOGINBAN',
    };
    const clientId = this.props.data.clientID.value;
    const scope = 'ONBEHALF';
    const token = helper.getUrlParameter('token');
    const idNumber = helper.getUrlParameter('idNumber');
    const phoneNumber = helper.getUrlParameter('phoneNumber');
    const ban = helper.getUrlParameter('ban');
    const actionType = helper.getUrlParameter('actionType')?.trim();
    const templateId = helper.getUrlParameter('templateId')?.trim();
    const redirectUrl = helper.getUrlParameter('redirectUrl')?.trim();
    const orgIdNumber = helper.getUrlParameter('orgIdNumber')?.trim();
    const consumerId = helper.getUrlParameter('consumerId')?.trim();
    const guidId = helper.getUrlParameter('guidId')?.trim();

    const redirectItem = this.props.data.redirectData.expandedValue?.find(
      (data: JetRedirectDataData) => actionType?.toLowerCase() == actionKey[data.actionKey?.value]?.toLowerCase(),
    ) as JetRedirectDataData | undefined;

    const returnUrl = redirectItem?.returnPage?.value?.url;
    const loginType = loginTypeEnum[redirectItem?.login_Type?.value];

    authenticationProvider.clearAuthenticationData().then(() => {
      authenticationProvider.launchInContextRedirect({
        clientId,
        scope,
        token,
        idNumber,
        phoneNumber,
        returnUrl,
        ban,
        loginType,
        templateId,
        actionType,
        redirectUrl,
        orgIdNumber,
        consumerId,
        guidId,
      });
    });
  }

  public render(): ReactNode | null {
    return <div></div>;
  }
}
